import React, {useContext, useEffect, useRef, useState} from 'react';
import {colors, sizes} from "../../utils/styled/_variables.styled";
import {InfiosBreadcrumb} from './Breadcrumb.style';
import Links from './Links/Links';
import Icon from '../Icon/Icon';
import {useIsMobile} from "../../utils/styled/_mixins.style";
import {ErrorBoundary} from "react-error-boundary";
import LinksAuto from './Links/LinksAuto';
import {urlHasParam} from "../../utils/js/params";
import {StateContext} from "../../context/stateContext";


const Breadcrumb = props => {
    const {
        breadcrumbList, home, homePath, selector, hideCurrent, isOverlaping, overlapType, parsedAutomaticBreadcrumbList, id
    } = props;

    const icon = "data:image/svg+xml,%3Csvg width='12' height='14' viewBox='0 0 12 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1.5 12.5H3.5V7.5H8.5V12.5H10.5V5.25L6 1.875L1.5 5.25V12.5ZM0 14V4.5L6 0L12 4.5V14H7V9H5V14H0Z' fill='{COLOR}'/%3E%3C/svg%3E";

    const colorSelector = (selector === 'white' || selector === 'blue');

    let iconWhite = icon.replace('{COLOR}', encodeURIComponent(colors.white));
    let iconBlack = icon.replace('{COLOR}', encodeURIComponent(colors.infiosGray));
    let iconBlue = icon.replace('{COLOR}', encodeURIComponent(colors.blueHover));
    let iconBluePressed = icon.replace('{COLOR}', encodeURIComponent(colors.bluePressed));

    const [isOpen, setIsOpen] = useState(true);
    const [showButton, setShowButton] = useState(true);
    const [l3Position, setL3Position] = useState(0);

    const { isMobile } = useIsMobile(sizes.tabletLarge);

    useEffect(() => {
        if(isOverflown(breadcrumbsWrapper.current)){
						if(overlapType != "stageL3"){
            	setIsOpen(false);
						}
            setShowButton(true);
            return;
      }
      setIsOpen(true);
      setShowButton(false);
    }, [isMobile])

    const breadcrumbsWrapper = useRef();

    function isOverflown(element) {
        if(element){
            let children = element.lastChild;
            let box = children.getBoundingClientRect();

            return (box.right + 161) > element.clientWidth;
        }
    }

    useEffect(() => {
      let subItems = document.getElementsByClassName("cmp-breadcrumb__item");
      let itemsLength = subItems.length;
      for (let i = 0; i < itemsLength; i++) {
        if (i !== itemsLength - 1) {
          if (!isOpen) {
            subItems[i].style.display = "none";
          } else {
            subItems[i].style.display = "block";
          }
        }
      }
    }, [isOpen]);

    const unsetGrid = useRef(null);

    useEffect(() => {
        if(unsetGrid.current){
            unsetGrid.current.parentElement.classList.add(`unset__grid`);
            unsetGrid.current.style.opacity = "100%";
        }

        },[]);

    const handleBreadcrumbToggle = (event) => {
        event.preventDefault();
        setShowButton(false);
        setIsOpen(!isOpen);
    }

    return(
        <InfiosBreadcrumb id={id} style={{minHeight: "82px", opacity: 0}} ref={unsetGrid} isOverlaping={isOverlaping} overlapType={overlapType} l3Position={l3Position} iconWhite={iconWhite} iconBlack={iconBlack} iconBlue={iconBlue}
                            iconBluePressed={iconBluePressed} selector={selector ? selector : 'black'} colorSelector={colorSelector}>
            { breadcrumbList ?
                <nav className="cmp-breadcrumb">
                    <ol ref={breadcrumbsWrapper} className="cmp-breadcrumb__list breadcrumbOverflow">
                            <>
                                <a className='cmp-breadcrumb__link' href={homePath}>
                                    < Icon className="cmp-breadcrumb__home" icon="home" />
                                    {!showButton ?
                                        < Icon className="cmp-breadcrumb__arrow" icon="chevron-right" color={colorSelector ? colors.white : colors.gray3 } />
                                    : <button onClick={handleBreadcrumbToggle} className="cmp-breadcrumb__toggle">
                                        <Icon className="cmp-breadcrumb__ellipsis" icon='ellipsis' />
                                      </button>
                                    }
                                </a>
                            </>
                        <Links linkArray={breadcrumbList} selector={selector} colorSelector={colorSelector} hideCurrent={hideCurrent}/>
                    </ol>
                </nav>
                :
                <nav className="cmp-breadcrumb">
                    <ol ref={breadcrumbsWrapper} className="cmp-breadcrumb__list breadcrumbOverflow">
                        <a className='cmp-breadcrumb__link' href={homePath}>
                            < Icon className="cmp-breadcrumb__home" icon="home" />
                            {!showButton ?
                                < Icon className="cmp-breadcrumb__arrow" icon="chevron-right" color={colorSelector ? colors.white : colors.gray3 } />
                            : <button onClick={handleBreadcrumbToggle} className="cmp-breadcrumb__toggle">
                                <Icon icon='ellipsis' className="cmp-breadcrumb__ellipsis"/>
                            </button> }
                        </a>
                        <LinksAuto linkArray={parsedAutomaticBreadcrumbList.slice(1)} selector={selector} colorSelector={colorSelector} hideCurrent={hideCurrent}/>
                    </ol>
                </nav>
            }
        </InfiosBreadcrumb>

    )
}

const BreadcrumbHandleErrors = props => {
    return (
        <ErrorBoundary fallback={props.isInEditor || urlHasParam('wcmmode=disabled') ? <div style={{minHeight: '50px', display: 'flex', alignItems: 'center', backgroundColor: '#ffe1db'}}><p>The breadcrumb component is currently experiencing errors. Please try again later.</p></div> : <div></div>}>
            <Breadcrumb {...props}/>
        </ErrorBoundary>
    )
  }

export default BreadcrumbHandleErrors;
